module.exports = __webpack_public_path__ + "img/1.1.829ca813.png";